import axios from 'axios'
import React, { useState } from 'react'

export const RegisterDoctror = () => {

    const [doctorName, setdoctorName] = useState('')
    const [doctoremail, setdoctoremail] = useState('')
    const [doctorpassword, setdoctorpassword] = useState('')

    var style = {
        minHeight: '299px',
    }

    const addDoctor = async (e) => {

        e.preventDefault()
        await axios.post("http://localhost:8080/doctor", {
            doctorName: doctorName,
            doctroEmail: doctoremail,
            doctorPassword: doctorpassword
        }).then(res => {
            console.log(res.data)
        })
    }
    return (
        <div>

            <div class="content" style={style}>
                <div class="container-fluid">

                    <div class="row">
                        <div class="col-md-8 offset-md-2">


                            <div class="account-content">
                                <div class="row align-items-center justify-content-center">
                                    <div class="col-md-7 col-lg-6 login-left">
                                        <img src="assets/img/login-banner.png" class="img-fluid" alt="Doccure Register" />
                                    </div>
                                    <div class="col-md-12 col-lg-6 login-right">
                                        <div class="login-header">
                                            <h3>Doctor Registration <a href="#">Are you a Paitent?</a></h3>
                                        </div>


                                        <form onSubmit = {addDoctor}>
                                            <div class="form-group form-focus">
                                                <input type="text" class="form-control floating" onChange={(e) => { setdoctorName(e.target.value) }} />
                                                <label class="focus-label">Name</label>
                                            </div>
                                            <div class="form-group form-focus">
                                                <input type="text" class="form-control floating"
                                                    onChange={(e) => { setdoctoremail(e.target.value) }} />

                                                <label class="focus-label">Email</label>
                                            </div>
                                            <div class="form-group form-focus">
                                                <input type="password" class="form-control floating"
                                                    onChange={(e) => { setdoctorpassword(e.target.value) }} />

                                                <label class="focus-label">Password</label>
                                            </div>
                                            <div class="text-right">
                                                <a class="forgot-link" href="login.html">Already have an account?</a>
                                            </div>
                                            <button class="btn btn-primary btn-block btn-lg login-btn" type="submit">Signup</button>
                                            <div class="login-or">
                                                <span class="or-line"></span>
                                                <span class="span-or">or</span>
                                            </div>
                                            <div class="row form-row social-login">
                                                <div class="col-6">
                                                    <a href="#" class="btn btn-facebook btn-block"><i class="fab fa-facebook-f mr-1"></i> Login</a>
                                                </div>
                                                <div class="col-6">
                                                    <a href="#" class="btn btn-google btn-block"><i class="fab fa-google mr-1"></i> Login</a>
                                                </div>
                                            </div>
                                        </form>


                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>

                </div>

            </div>
        </div>
    )
}

